// HorizontalNav.js
import React, { useState } from "react";
import ProfileModify from "./ProfileModify";
import Preferences from "./Preferences";
import Securite from "./Securite";

const TABS = [
  { id: "profile", label: "Modifier le profil", Component: ProfileModify },
  { id: "preferences", label: "Préférences", Component: Preferences },
  { id: "security", label: "Sécurité", Component: Securite },
];

export default function SettingsNavigation() {
  const [activeIndex, setActiveIndex] = useState(0);
  const ActiveComponent = TABS[activeIndex].Component;
  const activeTab = TABS[activeIndex];

  return (
    <div>
      {/* smooth panel transition (respects reduced motion) */}
      <style>{`
        @keyframes pm-panel-in {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .pm-panel-in { animation: pm-panel-in .35s cubic-bezier(.22,1,.36,1) both; }
        @media (prefers-reduced-motion: reduce) { .pm-panel-in { animation: none; } }
      `}</style>

      {/* ---------- Tabs ---------- */}
      <div
        role="tablist"
        aria-label="Paramètres"
        className="relative grid p-1 rounded-[16px] bg-white/[0.04] border border-[#ffffff1a] w-full"
        style={{ gridTemplateColumns: `repeat(${TABS.length}, minmax(0, 1fr))` }}
      >
        {/* sliding indicator */}
        <span
          aria-hidden="true"
          className="absolute top-1 bottom-1 left-1 rounded-[12px] bg-gradient-to-r from-[#113BE1] via-[#4268FF] to-[#113BE1] shadow-lg shadow-[#113BE1]/30 transition-transform duration-500 ease-[cubic-bezier(.22,1,.36,1)]"
          style={{
            width: `calc((100% - 8px) / ${TABS.length})`,
            transform: `translateX(${activeIndex * 100}%)`,
          }}
        />
        {TABS.map(({ id, label }, index) => {
          const selected = index === activeIndex;
          return (
            <button
              key={id}
              type="button"
              role="tab"
              id={`settings-tab-${id}`}
              aria-selected={selected}
              aria-controls={`settings-panel-${id}`}
              onClick={() => setActiveIndex(index)}
              className={`relative z-10 h-11 px-2 sm:px-3 rounded-[12px] truncate text-[12px] md:text-[14px] font-medium transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/50 ${
                selected ? "text-white" : "text-white/55 hover:text-white/85"
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>

      {/* ---------- Active panel (key remounts it, replaying the animation) ---------- */}
      <div
        key={activeTab.id}
        role="tabpanel"
        id={`settings-panel-${activeTab.id}`}
        aria-labelledby={`settings-tab-${activeTab.id}`}
        className="content pm-panel-in"
      >
        <ActiveComponent />
      </div>
    </div>
  );
}